module.exports = __webpack_public_path__ + "static/FoundersGrotesk-RegularItalic-5fc263c20169d51b0fae893359f7cef0.woff2";